/* eslint-disable react/require-default-props,react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import partition from 'lodash/partition';

import {
  COMMUNITY_POSTS,
  COMMUNITY_POSTS_EMPTY,
  COMMUNITY_POSTS_EMPTY_SUB,
  COMMUNITY_POSTS_PRIVATE,
} from '../../constants/strings';

import EmptyContent from '../common/EmptyState/Content';
import PostPreview from '../PostPreview';
import SectionTitle from './SectionTitle';

import { actions as deletePostActions } from '../../redux/communities/deletePost';
import { actions as editPostActions } from '../../redux/communities/editPost';
import { loggedUserIdSelector } from '../../redux/context/selectors';
import { COMMUNITY_TYPES } from '../../constants/props';

import styles from './index.styl';

const HEADER_HEIGHT = 56;

const mapStateToProps = state => ({
  postDetails: state.communities.postDetails,
  currentUserId: loggedUserIdSelector(state),
});

const mapDispatchToProps = {
  deletePost: deletePostActions.send,
  editPost: editPostActions.send,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class Posts extends Component {
  static propTypes = {
    communityId: PropTypes.number,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    list: PropTypes.arrayOf(PropTypes.object),
    postDetails: PropTypes.shape({
      id: PropTypes.number,
    }),
    deletePost: PropTypes.func,
    editPost: PropTypes.func,
    isModerator: PropTypes.bool,
    currentUserId: PropTypes.number,
    type: PropTypes.string,
    communityName: PropTypes.string,
    currentUserRole: PropTypes.string,
  };

  timeoutId;

  componentDidMount() {
    const {
      postDetails: { id },
    } = this.props;

    if (id) {
      this.timeoutId = setTimeout(() => this.scrollToItem(id), 0);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  scrollToItem(id) {
    const targetElement =
      this.ref && this.ref.querySelector(`[data-id="${id}"]`);

    if (targetElement) {
      targetElement.scrollIntoView(true);

      // get top spacing equal community expandable header
      const scrolledElement = get(targetElement, 'offsetParent.children[0]');

      if (scrolledElement) {
        const header = document.querySelector('.community__header');
        const headerHeight = header && header.offsetHeight;

        scrolledElement.scrollTop -= headerHeight || HEADER_HEIGHT;
      }
    }
  }

  @autobind
  handleDeletePost(id) {
    const { deletePost, communityId } = this.props;

    deletePost({
      communityId,
      id,
    });
  }

  canDelete(post) {
    const { currentUserId, isModerator } = this.props;

    return isModerator || post.author.user.id === currentUserId;
  }

  @autobind
  handleEditPost(data) {
    this.props.editPost(data);
  }

  canEdit(post) {
    return post.author.user.id === this.props.currentUserId;
  }

  render() {
    const {
      communityId,
      intl,
      list,
      isModerator,
      currentUserRole,
      type,
      communityName,
    } = this.props;

    const { formatMessage } = intl;
    const isPrivateCommunity = type === COMMUNITY_TYPES.private;
    const isEmptyContent =
      (isPrivateCommunity && !currentUserRole) || isEmpty(list);
    const emptyContentIcon = isPrivateCommunity ? 'icon-megaphone' : 'no-posts';
    const emptyContentText = isPrivateCommunity
      ? formatMessage(COMMUNITY_POSTS_PRIVATE)
      : formatMessage(COMMUNITY_POSTS_EMPTY);
    const emptyContentSubtitle = formatMessage(COMMUNITY_POSTS_EMPTY_SUB, {
      name: communityName,
    });

    const [pinnedPost, otherPosts] = partition(list, 'pinned');
    const sortedList = pinnedPost.concat(otherPosts);

    return (
      <div
        styleName={classNames('posts', {
          'posts--empty': isEmptyContent,
        })}
      >
        <Choose>
          <When condition={isEmptyContent}>
            <EmptyContent icon={emptyContentIcon} text={emptyContentText} />
            <p styleName="subtitle">{emptyContentSubtitle}</p>
          </When>
          <Otherwise>
            <SectionTitle text={formatMessage(COMMUNITY_POSTS)} />
            <ul styleName="posts__list" ref={node => (this.ref = node)}>
              {sortedList.map((post, i) => (
                <li key={post.id} className="pb3" data-id={post.id}>
                  <PostPreview
                    intl={intl}
                    onDelete={
                      this.canDelete(post)
                        ? () => this.handleDeletePost(post.id)
                        : null
                    }
                    onEdit={this.canEdit(post) ? this.handleEditPost : null}
                    {...{ communityId }}
                    {...post}
                    isLink
                    isModerator={isModerator}
                    currentUserRole={currentUserRole}
                  />
                </li>
              ))}
            </ul>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/Posts.jsx